import { NEW_INSTALLMENT_APPLICATION_URL } from './installments';

// base urls
export const URL_BASE = {
	CZ: {
		title: 'skippay.cz',
		url: 'https://skippay.cz',
	},
	SK: {
		title: 'skippay.sk',
		url: 'https://skippay.sk',
	},
};

// blog is separate static Wordpress application
export const URL_BLOG = `https://skippay.cz/blog`;
export const URL_BLOG_OLD = `https://mallpay.cz/blog`;
export const URL_VOCABULARY = `https://skippay.cz/blog/slovnik-pojmu`;
export const URL_BLOG_PODCAST = `https://skippay.cz/blog/tema/podcasty`;
export const URL_DEVELOPERS_PORTAL = `https://developers.skippay.cz/`;
export const URL_VISUAL_MATERIALS = `https://kulyma.sharepoint.com/:f:/s/Public/ErqHaMMhfkJCmgIsSWBmnx8B8gp_Ku4Gm75ZZoeGQIYZZA?e=zg6DB0`;

export const ABOUT = '/o-skippay';
export const ABOUT_BREAKAGE_AND_THEFT_PROTECTION = '/ochrana-nakupu/ochrana-pri-rozbiti-a-kradezi';
export const ABOUT_CREDIT_CARD = '/kreditni-karta';
export const ABOUT_DEFERRED_PAYMENT = '/odlozena-platba';
export const ABOUT_HOW_PAY_BY_MALL_PAY = '/jak-zaplatit';
export const ABOUT_INSTALLMENT_PAYMENT = '/nakup-na-splatky';
export const ABOUT_INVESTMENTS = '/investuj-pri-nakupovani';
export const ABOUT_LOANS = '/pujcky';
export const ABOUT_ONLINE_PAYMENT = '/platba-online';
export const ABOUT_OVERDRAFT = '/kontokorent';
export const ABOUT_PAYMENT_BY_CARD = '/platba-kartou';
export const ABOUT_MALL_PAY = '/platba-skip-pay';
export const ABOUT_PAY_IN_THREE = '/nakup-na-tretinu';
export const ABOUT_PAYMENT_GATEWAY = '/platebni-brana';
export const ABOUT_PAYMENT_ON_DELIVERY = '/dobirka';
export const ABOUT_REWARDS = '/odmeny';
export const ABOUT_SHOP_WISELY = '/nakupujte-s-rozumem';
export const ABOUT_TRANSACTION_PAYMENT = '/prevod-penez';
export const ABOUT_TRANSACTION_PROTECTION = '/ochrana-nakupu';
export const ABOUT_TRANSACTION_PROTECTION_DOCUMENTS = '/ochrana-nakupu/dokumenty';
export const ACCOUNT_UPGRADE = '/skip-balicky';
export const ADDRESS_BOOK = '/poslat-platbu/adresar';
export const APP_STORE_REDIRECT = '/chci-aplikaci';
export const APPLICATION_DETAIL = '/nakupy/:applicationId';
export const APPLICATION_LISTING = '/nakupy';
export const BILLING_PAYMENT = '/nakupy-a-platby/:billingId/zaplatit';
export const BILLING_PART_PAYMENT = '/zaplatit-cast-vyuctovani';
export const BILLINGS = '/nakupy-a-platby';
export const BILLINGS_ALL = '/nakupy-a-platby/vsechny';
export const BILLINGS_ALL_FILTERED = '/nakupy-a-platby/vsechny/filter';
export const CARD = '/karta';
export const CAREER = '/kariera';
export const CAREER_DETAIL = '/kariera/:slug';
export const CASHBACK = '/cashback';
export const CASHBACK_TRANSACTIONS = '/cashback/transakce';
export const CASHBACK_WALLET = '/cashback/penezenka';
export const CONDITIONS = '/vseobecne-obchodni-podminky';
export const CONTACTS = '/kontakty';
export const CONTRACTS_AND_DOCUMENTS = '/smlouvy-a-dokumenty';
export const CONTRACTS_AND_DOCUMENTS_OTHER = '/smlouvy-a-dokumenty/ostatni';
export const CONTRACTS_AND_DOCUMENTS_PRICE_LIST = '/smlouvy-a-dokumenty/cenik';
export const CONTRACTS_AND_DOCUMENTS_TERMS = '/smlouvy-a-dokumenty/obchodni-podminky';
export const CONTRACTS_AND_DOCUMENTS_USER_CONTRACTS = '/smlouvy-a-dokumenty/smlouvy';
export const CONTRACTS_AND_DOCUMENTS_UPLOAD = '/smlouvy-a-dokumenty/nahrat-dokument';
export const DEFERRED_BILLING = '/odlozeni-splatnosti';
export const DEFERRED_BILLING_POSTPONEMENT_FREE = `${DEFERRED_BILLING}#posunuti-zdarma`;
export const DOCUMENTS = '/dokumenty';
export const DIRECT_DEBIT = '/inkaso';
export const DIRECT_DEBIT_SUCCESS = '/inkaso/uspech';
export const ESHOPS_LIST = '/kde-nakupovat';
export const ESHOPS_LIST_PAY_IN_THREE = `${ESHOPS_LIST}?meth=payInThree`;
export const ESHOPS_LIST_DEFERRED_PAYMENT = `${ESHOPS_LIST}?meth=deferredPayment`;
export const EXCHANGE_RATES = '/kurzovni-listek';
export const EXTENDED_WARRANTY = '/prodlouzena-zaruka';
export const EXTENDED_WARRANTY_TO_CARD = '/pojisteni-ke-karte/prodlouzena-zaruka';
export const FOR_JOURNALISTS = '/pro-novinare';
export const FOR_DEVELOPERS = '/pro-vyvojare';
export const FORGOTTEN_PASSWORD = '/zapomenute-heslo';
export const FORGOTTEN_PASSWORD_CALLBACK = '/zapomenute-heslo/:token';
export const GET_MALL_PAY = '/pro-eshop';
export const GET_MALL_PAY_DEFERRED_PAYMENT = '/pro-eshop/odlozena-platba';
export const GET_MALL_PAY_INSURANCE = '/pro-eshop/pojisteni';
export const HISTORICAL_APPLICATION_DETAIL = '/nakupy/moje/:applicationId';
export const INCREASE_LIMIT = '/navyseni-limitu';
export const INFORMATION_MEMORANDUM = '/informacni-memorandum';
export const CONTRACTS_AND_DOCUMENTS_INFORMATION_MEMORANDUM =
	'/smlouvy-a-dokumenty/informacni-memorandum';
export const INSURANCE = '/pojisteni';
export const INSURANCE_EVENT_REPORT = '/hlaseni-pojistne-udalosti';
export const INSURANCE_TO_CARD = '/pojisteni-ke-karte';
export const INSURANCE_CONDITIONS = '/pojisteni/pojistne-podminky';
export const INSTALLMENTS = '/rozlozeni-na-splatky';
export const INSTALLMENT_DETAIL = '/rozlozeni-na-splatky/:installmentId';
export const INSTALLMENT_APPLICATION_CREATE = `/rozlozeni-na-splatky/zadost/${NEW_INSTALLMENT_APPLICATION_URL}`;
export const INSTALLMENTS_APPLICATION_SELECT = '/rozlozeni-na-splatky/vyber';
export const INSTALLMENT_APPLICATION = '/rozlozeni-na-splatky/zadost/:applicationId';
export const INSTALLMENT_APPLICATION_PAYMENT = '/rozlozeni-na-splatky/:installmentId/zaplatit';
export const INSTALLMENT_APPLICATION_EXTRAORDINARY_PAYMENT =
	'/rozlozeni-na-splatky/:installmentId/mimoradna-splatka';
export const INSTALLMENT_APPLICATION_EARLY_PAYMENT =
	'/rozlozeni-na-splatky/:installmentId/predcasne-splaceni';
export const INSTALLMENTS_HISTORY = '/rozlozeni-na-splatky/historie';
export const INTRO = '/uvod';
export const INVESTMENTS = '/investice';
export const INVESTMENTS_MANAGEMENT = '/investice/sprava';
export const INVESTMENT_TRANSACTION = '/investice/transakce/:transactionId';
export const KNJ = '/knj';
export const KUP_NAJISTO = '/kup-najisto';
export const KYC_VERIFICATION = '/overeni';
export const LOGIN = '/prihlaseni';
export const LOGIN_EN = '/login';
export const LOGOUT = '/odhlaseni';
export const LYMET = '/lymet';
export const MALLPAY = '/mallpay';
export const MY_APPLICATION_LISTING = '/nakupy/moje';
export const MOBILE_APP = '/mobilni-aplikace';
export const OPEN_API = '/openapi';
export const OVERVIEW = '/prehled';
export const PACKAGES = '/balicky';
export const PARTNERS = '/partneri';
export const PASSWORD_CHANGE = '/zmena-hesla';
export const PASSWORD_SET = '/nastaveni-hesla';
export const PAY_IN_THREE = '/tretiny';
export const PAY_IN_THREE_DETAIL = '/tretiny/:applicationId';
export const PAY_IN_THREE_DETAIL_PAYMENT = '/tretiny/:applicationId/zaplatit';
export const PAYMENT = '/zaplatit/:applicationIds';
export const PAYMENT_GATEWAY = '/payment';
export const PAYMENT_PARTIAL = `/zaplatit`;
export const PAYMENT_CARD = '/platebni-karta';
export const PERSONAL_DATA = '/sprava-osobnich-udaju';
export const PERSONAL_DATA_CALLBACK = '/sprava-osobnich-udaju/:token';
export const PRESS_RELEASES = '/tiskove-zpravy';
export const PRESS_RELEASE_DETAIL = '/tiskove-zpravy/:slug';
export const PRICING = '/cenik';
export const PRIVACY_SETTINGS = '/nastaveni-soukromi';
export const PRIVATE_CAMPAIGN = '/private/campaign';
export const PRIVATE_SIMPLEID_TOOL = '/private/simpleidtool';
export const PROFILE = '/profil';
export const PROTECTION_TO_CARD_BREAK_THEFT = '/pojisteni-ke-karte/ochrana-rozbiti-kradez';
export const PUBLIC_REFERRALS = '/doporucte-nas';
export const PUBLIC_SUPPORT = '/caste-dotazy';
export const PUBLIC_SUPPORT_CATEGORY = '/caste-dotazy/:categorySlug';
export const PUBLIC_SUPPORT_QUESTION = '/caste-dotazy/:categorySlug/:questionSlug';
export const PEP_QUESTIONNAIRE = '/pep-dotaznik';

export const REFERRALS = '/doporuceni';
export const REFERRAL_LINK = '/doporuceni/:referrerToken';
export const REGISTRATION = '/registrace';
export const REGISTRATION_EN = '/registration';
export const REGISTRATION_CALLBACK = '/dokonceni-registrace/:token';
export const REGISTRATION_COMPLETION = '/dokonceni-registrace';
export const REGISTRATION_CSOB_PROMO = '/csob'; // TODO vno20190608: remove after promo end
export const REGISTRATION_SUCCESS = '/registrace-uspech';
export const REVOLVING_TRANSACTION_DETAIL = '/nakupy-a-platby/transakce/:transactionId';
export const AUTHORIZATION_TRANSACTION_DETAIL = '/nakupy-a-platby/autorizace/:transactionId';
export const REWARD_FREE_DELIVERY_PATH = `doprava-na-vydejny-zdarma`;
export const REWARDS = '/prehled-odmen';
export const REWARD_FREE_DELIVERY = `${REWARDS}/${REWARD_FREE_DELIVERY_PATH}`;
export const REWARDS_BENEFITS = '/prehled-odmen/vyhody-od-skip-pay';
export const REWARDS_FROM_PARTNERS = '/prehled-odmen/slevy-na-nakupy';
export const REWARDS_PROMOCODE_OFFER_DETAIL = '/prehled-odmen/:promocodeOfferId';
export const REWARDS_PROMOCODES_OFFERS = '/prehled-odmen/nabidka';
export const REWARDS_PURCHASED_PROMOCODE_DETAIL = '/prehled-odmen/moje/:promocodeOfferId';
export const REWARDS_PURCHASED_PROMOCODES = '/prehled-odmen/moje';
export const REWARDS_TRANSACTION_HISTORY = '/prehled-odmen/historie';
export const RECEIPTS = '/uctenky';
export const ROOT = '/';
export const SEND_MONEY = `/poslat-platbu`;
export const SEND_MONEY_PAYMENT_INFORMATION = `/poslat-platbu/platebni-udaje`;
export const PAYMENT_ORDER_TEMPLATES = '/opakovane-platby';
export const PAYMENT_ORDER_TEMPLATE = '/opakovane-platby/:templateId';
export const SIMPLE_ID = '/overeni-mobilem';
export const SMS = '/sms';
export const TESTIMONIAL = '/recenze-klientu';
export const WHEEL_OF_FORTUNE = '/prehled-odmen/kolo-stesti';
export const BILLING_DEFERMENT_FOR_COINS = 'odlozeni-zdarma-za-body';
export const XMAS = '/zaplatim-po-vanocich';
export const AFFILIATE_PAGE = '/slevy';
export const AFFILIATE_PAGE_DETAIL = '/slevy/:slug';
export const INFORMATION_MEMORANDUM_GENERATED_HTML = '/dokumenty/generated/informacni-memorandum';
export const PRIVACY_POLICY_GENERATED_HTML = '/dokumenty/generated/privacy-policy';
export const DEBT_REPAYMENT_CONFIRMATION = '/splatkovy-kalendar/zadost/:applicationId';
export const PAYMENT_DATA = '/platebni-udaje/:token';

// mobile routes used in self-care components
export const AUTHORIZATION_DETAIL = '/potvrzeni/:authorizationId';
export const AUTHORIZATION_SETTING_INFO = '/potvrzovani-transakci';
export const CONTACT = '/kontakt';
export const MAP = '/mapa';
export const MAP_DETAIL = '/mapa/:id';
export const MORE = '/vice';
export const PIN_CHANGE = '/pin/zmena';
export const WELCOME = '/vitejte';

// external
export const APP_ANDROID = 'https://play.google.com/store/apps/details?id=cz.mallpay&hl=cs';
export const APP_IPHONE = 'https://apps.apple.com/app/id1450758826';
export const URL_FACEBOOK = 'https://www.facebook.com/SkipPay/';
export const URL_LINKEDIN = 'https://www.linkedin.com/company/skip-pay/';
export const URL_INSTAGRAM = 'https://www.instagram.com/skip_pay/';
export const URL_MOB_APP_APPLE_APP_STORE = `https://apps.apple.com/app/id1450758826`;
export const URL_MOB_APP_GOOGLE_PLAY = `https://play.google.com/store/apps/details?id=cz.mallpay&hl=cs`;
export const URL_YOUTUBE = 'https://www.youtube.com/channel/UC56ivZwb5fjA7ClI49aMyIg';
export const CREATE_CSOB_ACCOUNT = 'https://www.csob.cz/lide/ucty/skippay';
export const CSOB_ONLINE_BANKING_LOGIN = 'https://identita.csob.cz/prihlaseni/#csob-ib';
export const SMART_MOBILE_ONLINE_BANKING_LOGIN = 'https://smart.csob.cz/smartbanking/login';

// CS / SK Routes

const CS_ROUTES = {
	conditions: CONDITIONS,
	informationMemorandum: INFORMATION_MEMORANDUM,
	informationMemorandumGenerated: INFORMATION_MEMORANDUM_GENERATED_HTML,
	support: PUBLIC_SUPPORT,
	supportCategory: PUBLIC_SUPPORT_CATEGORY,
	supportQuestion: PUBLIC_SUPPORT_QUESTION,
	mobileApp: MOBILE_APP,
};

const SK_ROUTES = {
	conditions: '/vseobecne-obchodne-podmienky',
	informationMemorandum: '/informacne-memorandum',
	informationMemorandumGenerated: '/dokumenty/generated/informacne-memorandum',
	support: '/casto-kladene-otazky',
	supportCategory: '/casto-kladene-otazky/:categorySlug',
	supportQuestion: '/casto-kladene-otazky/:categorySlug/:questionSlug',
	mobileApp: '/mobilna-aplikacia',
};

export const ROUTES = (locale = 'cs') => {
	switch (locale) {
		case 'cs':
			return CS_ROUTES;
		case 'sk':
			return SK_ROUTES;
		default:
			throw new Error('Locale is not supported yet');
	}
};
